import { ModuleWithProviders, NgModule } from '@angular/core';

import { PluginService } from './services/plugin.service';
import { PluginSlotComponent } from './components/slot/slot.component';
import { PluginTemplate } from './templates/plugin/plugin.component';
import { CommonModule } from '@angular/common';
import { PluginComponent } from './components/plugin/plugin.component';
import { PluginEmptyTemplate } from './templates/empty/empty.component';
import { LocalizationModule } from '../localization/localization.module';
import { PluginService2 } from './services/plugin2.service';
import { ActionsPlugin } from './components/actions/actions.plugin';

@NgModule({
    imports: [CommonModule, LocalizationModule],
    declarations: [PluginSlotComponent, PluginComponent, PluginTemplate, PluginEmptyTemplate, ActionsPlugin],
    // TODO: check if we need to declare everything as entryComponent
    entryComponents: [PluginSlotComponent, PluginComponent, PluginTemplate, PluginEmptyTemplate, ActionsPlugin],
    exports: [PluginSlotComponent, PluginComponent, PluginTemplate, PluginEmptyTemplate, ActionsPlugin],
    providers: []
})
export class PluginsModule {

    public static forRoot(): ModuleWithProviders {

        return {
            ngModule: PluginsModule,
            providers: [PluginService, PluginService2]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/plugins.module.ts